import { lazy } from "react";
import ServicesTicker from "./components/ServicesTicker";

export const HOME_SECTIONS = [
  {
    key: "featured-products",
    Component: lazy(() => import("./components/FeaturedProducts")),
  },
  {
    key: "services-ticker",
    Component: ServicesTicker,
    defer: false,
    animate: false,
  },
  {
    key: "audit-report",
    Component: lazy(() => import("./components/AuditReportContents")),
  },
  {
    key: "made-in-india",
    Component: lazy(() => import("./components/MadeInIndia")),
  },
  {
    key: "product-ecosystem",
    Component: lazy(() => import("./components/ProductEcosystem")),
  },
  {
    key: "blog",
    Component: lazy(() => import("./components/BlogSection")),
  },
  {
    key: "trust",
    Component: lazy(() => import("./components/TrustSection")),
  },
  {
    key: "testimonials",
    id: "testimonials",
    Component: lazy(() => import("./components/Testimonilas")),
  },
  {
    key: "trusted-by",
    Component: lazy(() => import("./components/TrustedBy")),
  },
  {
    key: "mobile-app",
    Component: lazy(() => import("./components/JaaGaMobileSectionSection")),
  },
];
